import { useEffect, useState } from "react";
import { apiFetch } from "../../api/Api";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import {
  Autocomplete,
  TextField,
  IconButton,
  CircularProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { Link } from "react-router-dom";

function VillageList() {
  const [wards, setWards] = useState([]);
  const [wardId, setWardId] = useState("");
  const [villages, setVillages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [editId, setEditId] = useState(null);
const [editName, setEditName] = useState("");

  useEffect(() => {
    fetchWards();
  }, []);

  const fetchWards = async () => {
    const res = await apiFetch("super_admin/list_ward");
    setWards(res.wards);
  };

  const fetchVillages = async (id) => {
    setLoading(true);
    const res = await apiFetch(
      `super_admin/list_village?ward_id=${id}`
    );
    setVillages(res.villages || []);
    setLoading(false);
  };
// handleDelete
  const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this village?")) return;

  try {
    await apiFetch(`super_admin/delete_village/${id}`, {
      method: "DELETE",
    });

    fetchVillages(wardId);

  } catch (error) {
    console.error(error);
  }
};

// handle edit 
const handleEdit = (village) => {
  setEditId(village.village_id);
  setEditName(village.village_name);
};
const handleUpdate = async (id) => {
  try {
    await apiFetch(`super_admin/edit_village/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ village_name: editName }),
    });

    setEditId(null);
    fetchVillages(wardId);

  } catch (error) {
    console.error(error);
  }
};

return (
  <DashboardLayout>
    <DashboardNavbar />

    <div className="container-fluid mt-4" style={{ fontSize: "0.9rem" }}>

      {/* Gradient Header */}
      <div
        className="p-4 rounded-4 shadow-lg mb-4 text-white d-flex justify-content-between align-items-center"
        style={{
          background: "linear-gradient(135deg, #002B5B, #007BFF)",
        }}
      >
        <div>
          <h4 className="fw-bold mb-1" style={{ fontSize: "1.2rem" }}>
            🏘 Ward Area Management
          </h4>
          <small style={{ fontSize: "0.85rem" }}>Manage ward-wise village / area list</small>
        </div>

       

        <Link
          to="/add_village"
          className="btn btn-light fw-semibold"
          style={{ fontSize: "0.8rem" }}
        >
          + Add Area
        </Link>
      </div>
      </div>

      {/* Main Card */}
      <div className="card shadow-lg rounded-4 border-0">
        <div className="card-body">

          {/* Ward Filter */}
          <div className="row mb-4">
            <div className="col-md-6">
              <Autocomplete
                options={wards}
                getOptionLabel={(option) =>
                  `Ward ${option.ward_number} - ${option.ward_name || ""}`
                }
                onChange={(event, newValue) => {
                  const id = newValue ? newValue.ward_id : "";
                  setWardId(id);
                  if (id) fetchVillages(id);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Filter by Ward"
                    fullWidth
                  />
                )}
              />
            </div>
          </div>

          {/* Table Section */}
          {loading ? (
            <div className="text-center py-5">
              <CircularProgress size={30} />
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover align-middle" style={{ fontSize: "0.85rem" }}>

                <thead
                  className="text-white"
                  style={{ backgroundColor: "#002B5B" }}
                >
                  <tr>
                    <th>Sr. No.</th>
                    <th>Ward Area Name</th>
                    <th className="text-center">Actions</th>
                  </tr>
                </thead>

                <tbody>
                  {villages.length > 0 ? (
                    villages.map((village, index) => (
                      <tr key={village.village_id}>

                        <td>{index + 1}</td>

                        <td className="fw-semibold">
                          {editId === village.village_id ? (
                            <input
                              type="text"
                              className="form-control form-control-sm"
                              value={editName}
                              onChange={(e) =>
                                setEditName(e.target.value)
                              }
                            />
                          ) : (
                            village.village_name
                          )}
                        </td>

                        <td className="text-center">
                          {editId === village.village_id ? (
                            <>
                              <button
                                className="btn btn-success btn-sm me-2"
                                onClick={() =>
                                  handleUpdate(village.village_id)
                                }
                              >
                                Save
                              </button>

                              <button
                                className="btn btn-secondary btn-sm"
                                onClick={() => setEditId(null)}
                              >
                                Cancel
                              </button>
                            </>
                          ) : (
                            <>
                              <IconButton
                                color="primary"
                                onClick={() => handleEdit(village)}
                              >
                                <EditIcon />
                              </IconButton>

                              <IconButton
                                color="error"
                                onClick={() =>
                                  handleDelete(village.village_id)
                                }
                              >
                                <DeleteIcon />
                              </IconButton>
                            </>
                          )}
                        </td>

                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4">
                        <span className="text-muted">
                          No villages found
                        </span>
                      </td>
                    </tr>
                  )}
                </tbody>

              </table>
            </div>
          )}

        </div>
      </div>

  </DashboardLayout>
);
}

export default VillageList;